import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import styles from "./styles/summary.module.css";
import { Rating } from "../SingleView/Rating";
import { RatingBar } from "./RatingBar";
import { useMobileDetect } from "@hooks/index";

export function Summary({ junipProduct, handleCloseDrawer, sizeRatings }) {
  const { t } = useTranslation("reviews");
  const currentDevice = useMobileDetect();
  const isMobile = currentDevice.isMobile();

  if (!junipProduct) {
    return null;
  }

  return (
    <header className={styles.summary}>
      <div className={styles.review}>
        <span className={styles.content}>
          <h3 className={styles.title}>
            {junipProduct?.rating_average?.toFixed(1)} {t("overall-rating")}
          </h3>

          <div>
            <Rating average={junipProduct.rating_average} reviewSection={true} width={30} />
          </div>
        </span>
        {/* {!isMobile && (
          <span>
            <button className={styles["review-button"]}>{t("Write a Review")}</button>
          </span>
        )} */}
      </div>

      {isMobile && <div className={styles.border}> </div>}

      {junipProduct?.rating_count >= 10 && (
        <div className={styles.bars}>
          <RatingBar sizeRatings={sizeRatings} />
        </div>
      )}
    </header>
  );
}

Summary.propTypes = {
  rating_average: PropTypes.number.isRequired,
  handleCloseDrawer: PropTypes.func.isRequired,
};
